import PropTypes from 'prop-types';

export const showTypeItemShape = {
  filterStatus: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
};
